/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import {Box} from 'atomic'
import {
  LinkIconContext,
} from 'foundry'
import {
  person
} from 'static/menus'
/* ------------------------------- Component -------------------------------- */
export default props => <Box bg='white' bs={[1]} p={[10]} >{person.map(item=> <LinkIconContext {...item} {...props} /> )}</Box>


// WEBPACK FOOTER //
// ./src/interface/entity/Person/PersonProfile/PersonProfileMenu/index.js